import type { Suggestions } from '@mint-sdk/api-recommendations';

export const SUGGESTION_FILTERS: (keyof Suggestions.AvailableFiltersType)[] = [
  'campaigns',
  'channels',
  'platforms',
];

export const selectSuggestionFilters = (
  filters: Suggestions.GetFilterRequestType,
) => {
  return SUGGESTION_FILTERS.map((key) => {
    const filter = filters[key];
    return { [key]: filter.length ? filter?.[0]?.split(',') : null };
  });
};

export const selectSuggestionSearchValue = (
  filters: Suggestions.GetFilterRequestType,
) => {
  return filters.campaignName;
};
